//import axios from 'axios';
import localforage from 'localforage'
import memoryDriver from 'localforage-memoryStorageDriver'
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import {interceptorResponse, interceptorError} from '@/helpers/interceptorResponse';

class API {
  async configure(){

    const forageStore = localforage.createInstance({
      driver: [
        localforage.INDEXEDDB,
        localforage.LOCALSTORAGE,
        memoryDriver._driver
      ],
      name: 'infohidro-cluster-saic-summary'
    });

    const cache = setupCache({
      maxAge: 15 * 60 * 1000,
      store: forageStore
    });

    const api = axios.create({
      adapter: cache.adapter,
      baseURL: `${process.env.VUE_APP_API_BASE_REST_TELEMETRIC_API_SANEPAR}`,
      timeout: 60000
    });

    api.interceptors.response.use(
      interceptorResponse,
      interceptorError
    );

    return api;
  }
}

export default API;
